import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import ReactDom from "react-dom";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import zIndices from "theme/z-indices";
import Preview from "./Preview";
const Backdrop = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  inset: 0;
  z-index: ${zIndices.confirmModalOverlay};

  background-color: rgb(0 0 0 / 50%);
`;
const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 600px;
  height: 65vh;
  top: 10vh;
  padding: 16px;

  background-color: ${({ theme }) => theme.colors.global.contentBackground};
  border: 1px solid ${({ theme }) => theme.colors.input.border};
  border-radius: 8px;
`;
const CloseIcon = styled(Icon)`
  margin-left: auto;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.input.placeholder};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  gap: 1rem;

  &#editor-body {
    flex-grow: 1;
  }
`;
function PreviewModal({ value, show, onClose }) {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    var _a;
    const contentHeight = (_a = document.getElementById("preview-body")) == null ? void 0 : _a.scrollHeight;
    setHeight(contentHeight);
  }, [show]);
  const Component = useMemo(
    () => show ? /* @__PURE__ */ React.createElement(Backdrop, { onClick: () => onClose() }, /* @__PURE__ */ React.createElement(Content, { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("h2", { style: { marginBottom: "1rem" } }, "Markdown Preview"), /* @__PURE__ */ React.createElement(CloseIcon, { name: "close", onClick: () => onClose() })), /* @__PURE__ */ React.createElement(Preview, { value, height, show: true }), /* @__PURE__ */ React.createElement(Row, { style: { justifyContent: "flex-end", marginTop: "1rem" } }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", role: "button", onClick: () => onClose() }, "Close")))) : null,
    [show, value, height, onClose]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ReactDom.createPortal(Component, document.body));
}
export default PreviewModal;
